import React from 'react';
import {observer} from "mobx-react";
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {ProfilePicture} from "./profile-picture/profile-picture.component";
import {Button} from '../../basic-ui-components/button/base/button.component';
import {OmgIndicator} from "../profile-box-messages-indicator/indicators/omg-indicator.component";
import {FreePlayIndicatorComponent} from "../profile-box-messages-indicator/indicators/freeplay-indicator.component";
import {ChallengesIndicator} from '../profile-box-messages-indicator/indicators/challenges-indicator.component';
import {ProfileMessagesDividerBox} from "./boxes/profile-messages-divider.box";
import { BalanceValue } from '../balance-box/balance-value.component';
import {ProfileButtonsBox} from "./boxes/profile-buttons.box";
import {ProfileCashierButtonBox} from "./boxes/profile-cashier-button/profile-cashier-button.box";
import {ProfileCashierAddButtonBox} from "./boxes/profile-cashier-button/profile-cashier-add-button/profile-cashier-add-button.box";
import {ProfileWrapperBox} from "./boxes/profile-wrapper.box";
import {ProfileMessagesBox} from "./boxes/profile-box-messages/profile-messages.box"
import classNames from 'classnames';
import {CyClass} from '../../../common/cy-classes';
import { IndicatorLayout } from '../profile-box-messages-indicator/consts/indicator-layout';
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core/lib/apps/app-enums";

const MARKETING_DL = '19520';

@observer
export class ProfileBox extends OrbitComponent<{}> {

    render() {

        return (
            <ProfileWrapperBox className={classNames(CyClass('cy-profile-box'))}>
                <ProfilePicture marketingDl={MARKETING_DL} />
                <ProfileButtonsBox className="cy-profile-box-buttons">
                    {this._renderLogin()}
                    {this._renderCashier()}
                </ProfileButtonsBox>
                {this._renderProfileBoxMessages()}
            </ProfileWrapperBox>
        );
    }

    private _renderProfileBoxMessages() {

        if (this.services.configuration.data.sideMenu.menu_links.myChallenges) {
            return (
                <>
                    <ProfileMessagesBox className="cy-profile-box-messages">
                        <ChallengesIndicator />
                        <ProfileMessagesDividerBox />
                        <FreePlayIndicatorComponent />
                    </ProfileMessagesBox>
                    <OmgIndicator displayLayout={IndicatorLayout.List} />
                </>
            );
        }

        return (
            <ProfileMessagesBox className="cy-profile-box-messages">
                <OmgIndicator />
                <ProfileMessagesDividerBox />
                <FreePlayIndicatorComponent />
            </ProfileMessagesBox>
        );
    }

    private _renderLogin() {

        if(this.services.user.isAuthorized) return null;

        return (
            <div className={CyClass('cy-profile-box-login-button')}>
                <Button
                    preset="secondaryInverted"
                    fullWidth
                    onClick={() => this._openLogin()}
                >{this.services.translation.translate("Login")}</Button>
            </div>
        );
    }

    private _renderCashier() {
        if (!this.services.user.isAuthorized) {
            return null;
        }

        const AddIcon = this.services.theme.currentTheme.icons.addIcon;
        return (
            <ProfileCashierButtonBox className={classNames(CyClass('cy-cashier-button'))} onClick={() => this._openCashier()}>
                <BalanceValue className={classNames(CyClass('cy-balance-box-amount'))} />
                <ProfileCashierAddButtonBox>
                    <AddIcon />
                </ProfileCashierAddButtonBox>
            </ProfileCashierButtonBox>
        );
    }

    private _openLogin() {
        this.services.analytics.sendAnalytics('Navigation', 'NavBar', 'CTA_Login');
        this.services.user.openLogin({}, {dl: MARKETING_DL});
    }

    private _openCashier() {
        this.services.userMenu.closeMenu();

        this.services.cashier.openDeposit({
            channel: {
                source: CHANNEL_SOURCE.casinoClient,
                area: AreaType.NavigationMenu,
                element: CHANNEL_ELEMENTS.plusButton
            }
        });
        this.services.analytics.sendAnalytics('Navigation', 'NavBar', 'Open_Cashier');
    }
}
